function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_19",
  "data-name": "Rectangle 19",
  width: 128,
  height: 128,
  fill: "#d8e0df"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-_1_1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 128,
  height: 128
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_1_1",
  "data-name": "1 \\u2013 1",
  clipPath: "url(#clip-_1_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "a",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_18",
  "data-name": "Ellipse 18",
  cx: 41,
  cy: 41,
  r: 41,
  transform: "translate(12 27)",
  fill: "#505762"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_19",
  "data-name": "Ellipse 19",
  cx: 27,
  cy: 27,
  r: 27,
  transform: "translate(48 10)",
  fill: "rgba(78,204,163,0.32)"
}), /*#__PURE__*/React.createElement("text", {
  id: "_2",
  "data-name": 2,
  transform: "translate(48 80)",
  fill: "#d8d9db",
  fontSize: 57,
  fontFamily: "Helvetica-Bold, Helvetica",
  fontWeight: 700,
  opacity: 0.818
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2"))));

var SvgNumber2 = function SvgNumber2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNumber2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/number-2.bf255f0e.svg";
export { ForwardRef as ReactComponent };